import { useTranslation } from 'react-i18next';

import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

/** Marks a staff-only category: it and every article in it stay off the storefront. */
export function InternalBadge({ className }: { className?: string }) {
  const { t } = useTranslation('helpCenter');
  return (
    <Badge
      variant="outline"
      className={cn('bg-info/15 text-info dark:bg-info/20 border-transparent', className)}
      title={t('visibilityHint.internal')}
    >
      {t('visibility.internal')}
    </Badge>
  );
}
